// extracted by mini-css-extract-plugin
export default {"JobworkPaymentsPage":"JobworkPaymentsPage_JobworkPaymentsPage__VmWoO"};